const findQuestionNumber = (module = {}) => {
  return (questionId) => [...module?.questions].findIndex(mq => mq.id === questionId) + 1
}

export {findQuestionNumber}